import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import './VehicleDetails.css';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
//import calculatorDemo from "./assets/calculatorDemo.jpg";

const VehicleDetails = () => {
    const { carId } = useParams();
    const [carDetails, setCarDetails] = useState(null);
    const [carImages, setCarImages] = useState([]);
    const [mainImageIndex, setMainImageIndex] = useState(0);
    const [thumbnailIndex, setThumbnailIndex] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartX, setDragStartX] = useState(0);

    useEffect(() => {
        fetch(`https://skcapi.btcjapan.co/get-car-details-with-images.php?id=${carId}`)
            .then(response => response.json())
            .then(data => {
                setCarDetails(data.carDetails);
                setCarImages([data.carDetails.images, ...data.carImages.map(img => img.image_path)]);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, [carId]);

    const handleThumbnailClick = (index) => {
        setMainImageIndex(index);
    };

    const handleArrowClick = (direction) => {
        if (direction === 'left') {
            setMainImageIndex((prevIndex) => (prevIndex === 0 ? carImages.length - 1 : prevIndex - 1));
        } else if (direction === 'right') {
            setMainImageIndex((prevIndex) => (prevIndex === carImages.length - 1 ? 0 : prevIndex + 1));
        }
    };

    const handleThumbnailArrowClick = (direction) => {
        if (direction === 'left') {
            setThumbnailIndex((prevIndex) => (prevIndex === 0 ? carImages.length - 1 : prevIndex - 1));
        } else if (direction === 'right') {
            setThumbnailIndex((prevIndex) => (prevIndex === carImages.length - 1 ? 0 : prevIndex + 1));
        }
    };

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        if (touchStartX === 0) return;

        const touchEndX = e.touches[0].clientX;
        const deltaX = touchStartX - touchEndX;

        if (deltaX > 50) {
            handleArrowClick('right');
            setTouchStartX(0);
        } else if (deltaX < -50) {
            handleArrowClick('left');
            setTouchStartX(0);
        }
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setDragStartX(e.clientX);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;

        const dragEndX = e.clientX;
        const deltaX = dragStartX - dragEndX;

        if (deltaX > 50) {
            handleArrowClick('right');
            setIsDragging(false);
        } else if (deltaX < -50) {
            handleArrowClick('left');
            setIsDragging(false);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    if (!carDetails) {
        return <div>Loading...</div>;
    }

    const requiredFeatures = [
        "abs",
        "airbag",
        "bluetooth",
        "cdPlayer",
        "dvd",
        "tv",
        "powerSteering",
        "powerWindow",
        "sunRoof",
        "leatherSeat",
        "alloyWheels",
        "ac",
        "radio",
        "caChanger",
        "powerSeat",
        "backTire",
        "grillGuard",
        "rearSpoiller",
        "centralLock",
        "jack",
        "spareTire",
        "wheelSpanner",
        "fogLights",
        "backCamera",
        "pushStart",
        "keylessEntry",
        "esc",
        "cam360deg",
        "bodyKit",
        "sideAirbag",
        "powerMirror",
        "sideSkirts",
        "frontLip",
        "navigation",
        "turbo",
        "powerDoor",
    ];

    const features = JSON.parse(carDetails.features || "{}");

    // Merge required features with database features
    const allFeatures = requiredFeatures.reduce((acc, feature) => {
        acc[feature] = features[feature] || false; // Default to false if feature is not in the database
        return acc;
    }, {});

    const featureNames = Object.keys(allFeatures);

    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    const featureRows = chunkArray(featureNames, 4);

    return (
        <>
            <div className="row">
                <div className="col-2 leftcol">
                    <LeftSection />
                </div>
                <div className="col-8 middlecol">
                    <div className="container my-4">
                        <div className="car-title">
                            <h2>{carDetails.maker} <span>{carDetails.model}</span></h2>
                        </div>

                        <div className="row">
                            <div className="col-md-8">
                                <div className="main-image-container">
                                    <img
                                        src={`https://skcapi.btcjapan.co/${carImages[mainImageIndex]}`}
                                        alt={carDetails.model}
                                        className="img-fluid main-image"
                                        onTouchStart={(e) => handleTouchStart(e)}
                                        onTouchMove={(e) => handleTouchMove(e)}
                                        onMouseDown={(e) => handleMouseDown(e)}
                                        onMouseMove={(e) => handleMouseMove(e)}
                                        onMouseUp={handleMouseUp}
                                        onMouseLeave={handleMouseUp}
                                    />
                                    <div className="arrow left-arrow" onClick={() => handleArrowClick('left')}>&#10094;</div>
                                    <div className="arrow right-arrow" onClick={() => handleArrowClick('right')}>&#10095;</div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <div className="thumbnail-container">
                                            <div className="thumbnail-arrow left-arrow" onClick={() => handleThumbnailArrowClick('left')}>&#10094;</div>
                                            <div className="thumbnail-arrow right-arrow" onClick={() => handleThumbnailArrowClick('right')}>&#10095;</div>
                                            <div className="thumbnail-wrapper" style={{ transform: `translateX(-${thumbnailIndex * 110}px)` }}>
                                                {carImages.map((image, index) => (
                                                    <img
                                                        key={index}
                                                        src={`https://skcapi.btcjapan.co/${image}`}
                                                        alt={`${carDetails.model} ${index}`}
                                                        className={`thumbnail ${index === mainImageIndex ? 'active' : ''}`}
                                                        onClick={() => handleThumbnailClick(index)}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="specs-table">
                                    <strong>Specification:</strong>
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Month/Year</th>
                                                <td>{carDetails.year}</td>
                                                <th>Color</th>
                                                <td>{carDetails.color}</td>
                                            </tr>
                                            <tr>
                                                <th>Mileage</th>
                                                <td>{carDetails.mileage} km</td>
                                                <th>Steering</th>
                                                <td>{carDetails.steering}</td>
                                            </tr>
                                            <tr>
                                                <th>Transmission</th>
                                                <td>{carDetails.transmission}</td>
                                                <th>Fuel</th>
                                                <td>{carDetails.fuel}</td>
                                            </tr>
                                            <tr>
                                                <th>Drive</th>
                                                <td>{carDetails.drive}</td>
                                                <th>Doors</th>
                                                <td>{carDetails.doors}</td>
                                            </tr>
                                            <tr>
                                                <th>Engine</th>
                                                <td>{carDetails.engine}</td>
                                                <th>Chassis</th>
                                                <td>{carDetails.vin}</td>
                                            </tr>
                                            <tr>
                                                <th>Model Code</th>
                                                <td>{carDetails.model_code}</td>
                                                <th>Maker</th>
                                                <td>{carDetails.maker}</td>
                                            </tr>
                                            <tr>
                                                <th>Model</th>
                                                <td>{carDetails.model}</td>
                                                <th>Price</th>
                                                <td>{carDetails.price}</td>
                                            </tr>
                                            <tr>
                                                <th>Country</th>
                                                <td>{carDetails.country}</td>
                                                <th>Version</th>
                                                <td>{carDetails.version}</td>
                                            </tr>
                                            <tr>
                                                <th>Location</th>
                                                <td>{carDetails.location}</td>
                                                <th>Seats</th>
                                                <td>{carDetails.seats}</td>
                                            </tr>
                                            <tr>
                                                <th>Dimension</th>
                                                <td>{carDetails.dimension}</td>
                                                <th>Weight</th>
                                                <td>{carDetails.weight} kg</td>
                                            </tr>
                                            <tr>
                                                <th>Stock ID</th>
                                                <td>{carDetails.stock_id}</td>
                                                <th>Body Type</th>
                                                <td>{carDetails.body_type}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="features-section">
                                    <strong>Features:</strong>
                                    <div className="table-responsive">
                                        <table className="table table-bordered mt-3">
                                            <tbody>
                                                {featureRows.map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {row.map((feature, colIndex) => (
                                                            <td
                                                                key={colIndex}
                                                                style={{
                                                                    backgroundColor: allFeatures[feature] ? '#FAE690' : '#F4F4F4',
                                                                    border: `1px solid ${allFeatures[feature] ? '#000000' : '#ddd'}`,
                                                                    margin: '5px',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                <div className="feature-label">
                                                                    {feature}
                                                                </div>
                                                            </td>
                                                        ))}
                                                        {/* Fill empty cells if the last row has less than 4 features */}
                                                        {row.length < 4 && Array(4 - row.length).fill().map((_, index) => (
                                                            <td key={`empty-${index}`}></td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>

                            <div className="col-md-4">




                                <div class="container-fluid">
                                    <div className="row justify-content-center">
                                        <div className="col-md-8 col-lg-12">
                                            <div className="calculator-container">
                                                <div className="vehicle-header">
                                           
                                                    <h2 className="mb-0">{carDetails.maker}</h2>
                                                    <h3 className="mb-1">{carDetails.model}</h3>
                          
                                                    <p className="mb-1">{carDetails.country}, {carDetails.location}</p>
                                                    <p className="mb-0">Stock Number: {carDetails.stock_id}</p>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Currency</label>
                                                    <select className="form-select">
                                                        <option selected>JPY</option>
                                                        <option>USD</option>
                                                        <option>EUR</option>
                                                    </select>
                                                </div>

                                                <div className="row mb-3">
                                                    <div className="col">
                                                        <label className="form-label">Interior:</label>
                                                        <span className="rating-star">★★★★★</span>
                                                    </div>
                                                    <div className="col">
                                                        <label className="form-label">Exterior:</label>
                                                        <span className="rating-star">★★★★★</span>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <h5>Vehicle State Evaluation Report</h5>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Car Price (FOB)</label>
                                                    <div className="input-group">
                                                        <span className="input-group-text">$</span>
                                                        <h4>{carDetails.price}</h4>
                                                        
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Country</label>
                                                    <select className="form-select">
                                                        <option selected disabled>Select country</option>
                                                        <option>United States</option>
                                                        <option>Canada</option>
                                                        <option>Australia</option>
                                                    </select>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Destination Port</label>
                                                    <select className="form-select">
                                                        <option selected disabled>Select port</option>
                                                        <option>Los Angeles</option>
                                                        <option>New York</option>
                                                        <option>Miami</option>
                                                    </select>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label">Marine Insurance</label>
                                                    <select className="form-select">
                                                        <option selected disabled>Select insurance option</option>
                                                        <option>Basic Coverage</option>
                                                        <option>Full Coverage</option>
                                                        <option>No Insurance</option>
                                                    </select>
                                                </div>

                                                <div className="mb-4 form-check">
                                                    <input type="checkbox" className="form-check-input" id="inspectionCheck" />
                                                    <label className="form-check-label" for="inspectionCheck">
                                                        Please select if Pre-ship inspection is required by your country regulation to import to your country.
                                                    </label>
                                                </div>

                                                <button className="btn btn-primary w-100 mb-3 py-2">Calculate</button>

                                                <div className="text-center text-muted mb-3">
                                                    <small>Completed in 1 minute</small>
                                                </div>

                                                <button className="btn btn-success w-100 py-2">Get A Free Quote</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-2 rightcol">
                    <RightSection />
                </div>
            </div>
        </>
    );
};

export default VehicleDetails;